import { http } from 'src/config';
import { URLSVC } from 'src/config/helper/urlService';
import Swal from 'sweetalert2'
import { loadingBar } from './globalAction';
import { setDataCombo } from './comboAction';

export const setDataAgencys = () => {
    return (dispatch) => {
        http.get(`${URLSVC}/Admins/GetListAgencies`).then((res) => {
            let data = res.data;
            if (data.IsSuccess) {
                dispatch({type: 'DATA_AGENCYS', payload: data.Data})
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const setDataAgency = (Code) => {
    return (dispatch) => {
        loadingBar(true);
        dispatch({type: 'RESET_FORM_AGENCY'})
        var Url = `${URLSVC}/Admins/GetAgencyByCode?Code=${Code}`;
        http.get(Url).then((res) => {
            loadingBar(false);
            let data = res.data;
            if (data.IsSuccess) {
                console.log(data.Data);
                dispatch({ type: 'DATA_AGENCY', payload: data.Data })

                dispatch(setFormAgency('Id', data.Data.Id))
                dispatch(setFormAgency('SectorId', data.Data.SectorId))
                dispatch(setFormAgency('Code', data.Data.Code))
                dispatch(setFormAgency('Name', data.Data.Name))
                dispatch(setFormAgency('Email', data.Data.Email))
                dispatch(setFormAgency('Website', data.Data.Website))
                dispatch(setFormAgency('Contact', data.Data.Contact))
                dispatch(setFormAgency('UrlFriendly', data.Data.UrlFriendly))
                dispatch(setFormAgency('ShortName', data.Data.ShortName))
                dispatch(setFormAgency('PhoneNumber', data.Data.PhoneNumber))
                dispatch(setFormAgency('Address', data.Data.Address))
                dispatch(setFormAgency('Description', data.Data.Description))
                dispatch(setFormAgency('FileLogo', data.Data.FileLogo))

                dispatch({type: 'MODAL_AGENCY', payload: true})
                
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const setFormAgency = (formType, formValue) => {
    return {type: 'FORM_AGENCY', formType, formValue}
}

export const apiAddUpdateAgency = (iData,reset) => {
    return (dispatch) => {
        loadingBar(true);
        console.log("ID NYA ",iData.Id);
        var fd = new FormData();
        var URL = ``;

        URL = `${URLSVC}/Admins/SaveAgency`;

        fd.append('Id', iData.Id);
        fd.append('SectorId', iData.SectorId.value === undefined ? iData.SectorId : iData.SectorId.value);
        fd.append('Name', iData.Name);
        fd.append('ShortName', iData.ShortName);
        fd.append('Code', iData.Code);
        fd.append('Email', iData.Email);
        fd.append('Website', iData.Website);
        fd.append('PhoneNumber', iData.PhoneNumber);
        fd.append('Contact', iData.Contact);
        fd.append('Description', iData.Description);
        fd.append('Address', iData.Address);
        fd.append('FileLogoUpload', iData.FileLogo[0]);
        
        http.post(URL,fd).then((res) => {
            loadingBar(false);
            let data = res.data;
            if (data.IsSuccess) {
                Swal.fire('Berhasil', `berhasil menyimpan organisasi pemerintah daerah`, 'success');
                dispatch({ type: 'MODAL_AGENCY', payload: false })
                reset();
                dispatch(setDataAgencys())
            } else {
                dispatch({ type: 'MODAL_AGENCY', payload: false })
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const apiDeleteAgency = (Id, Nama) => {
    return (dispatch) => {
        Swal.fire({
            title: 'Apakah anda yakin?',
            text: `Anda akan menghapus data (${Nama})!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya, saya yakin!'
        }).then((result) => {
            if (result.isConfirmed) {
                var fd = new FormData();
                fd.append('Id', Id);
                http.post(`${URLSVC}/Admins/DeleteAgency`,fd).then((res) => {
                    let data = res.data;
                    if (data.IsSuccess) {
                        Swal.fire('Berhasil', `Anda berhasil menghapus data (${Nama})`, 'success')
                        dispatch(setDataAgencys())
                    } else {
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
            }
        })
    }
}
